import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";

function UtilityBillCollection() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const baseLocationOptions = [
        { label: "form", value: "F" },
        { label: "page", value: "P" },
    ];
    const formik = useFormik({
        initialValues: {
            name: "",
            billingMonth: "",
            dueDate: "",
            beforeDueDateAmount: "",
            surcharges: "",
            afterDueDateAmount: "",
            paymentMode: "",
            accountNumber: "",
            cheaqueNumber: "",
            payOrder: "",
            RecieveAmount: "",
            accessSort: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.name) {
                errors.name = "This field is required.";
            }
            if (!data.billingMonth) {
                errors.billingMonth = "This field is required.";
            }
            if (!data.dueDate) {
                errors.dueDate = "This field is required.";
            }
            if (!data.beforeDueDateAmount) {
                errors.beforeDueDateAmount = "This field is required.";
            }
            if (!data.surcharges) {
                errors.surcharges = "This field is required.";
            }
            if (!data.afterDueDateAmount) {
                errors.afterDueDateAmount = "This field is required.";
            }
            if (!data.paymentMode) {
                errors.paymentMode = "This field is required.";
            }
            if (!data.accountNumber) {
                errors.accountNumber = "This field is required.";
            }
            if (!data.cheaqueNumber) {
                errors.cheaqueNumber = "This field is required.";
            }
            if (!data.payOrder) {
                errors.payOrder = "This field is required.";
            }
            if (!data.RecieveAmount) {
                errors.RecieveAmount = "This field is required.";
            }
            if (!data.accessSort) {
                errors.accessSort = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            // await handlePostRequest(data, "zbiz/nonFin/saveBranchUser");
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Utility Bill Collection</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-field p-col-12 p-md-12">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="baseLocationId" className={classNames({ "p-error": isFormFieldValid("baseLocationId") }, "Label__Text")}>
                                        Utility Company<span className="Label__Required">*</span>
                                    </label>
                                    <Dropdown
                                        id="baseLocationId"
                                        placeholder="select"
                                        options={baseLocationOptions}
                                        optionLabel="description"
                                        name="baseLocationId"
                                        value={formik.values.baseLocationId}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("baseLocationId") }, "Dropdown__Round")}
                                    />
                                    {getFormErrorMessage("baseLocationId")}
                                </div>
                            </div>

                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="consumerNumber" className={classNames({ "p-error": isFormFieldValid("consumerNumber") }, "Label__Text")}>
                                        Consumer Number
                                    </label>
                                    <InputText id="consumerNumber" placeholder="Consumer Number" name="consumerNumber" value={formik.values.consumerNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("consumerNumber") }, "Input__Round")} />

                                    {getFormErrorMessage("consumerNumber")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} label="Fetch" className="Btn__Dark" />
                    </div>
                </form>
            </div>
            <br />
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Bill Information</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-field p-col-12 p-md-12">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") }, "Label__Text")}>
                                        Name
                                    </label>
                                    <InputText id="name" placeholder="auto" name="name" value={formik.values.name} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("name") }, "Input__Round")} />

                                    {getFormErrorMessage("name")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="billingMonth" className={classNames({ "p-error": isFormFieldValid("billingMonth") }, "Label__Text")}>
                                        Billing Month
                                    </label>
                                    <InputText id="billingMonth" placeholder="auto" name="billingMonth" value={formik.values.billingMonth} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("billingMonth") }, "Input__Round")} />

                                    {getFormErrorMessage("billingMonth")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="dueDate" className={classNames({ "p-error": isFormFieldValid("dueDate") }, "Label__Text")}>
                                        Due Date
                                    </label>
                                    <InputText id="dueDate" placeholder="auto" name="dueDate" value={formik.values.dueDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("dueDate") }, "Input__Round")} />

                                    {getFormErrorMessage("dueDate")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="beforeDueDateAmount" className={classNames({ "p-error": isFormFieldValid("beforeDueDateAmount") }, "Label__Text")}>
                                        Before Due Date Amount
                                    </label>
                                    <InputText id="beforeDueDateAmount" placeholder="auto" name="beforeDueDateAmount" value={formik.values.beforeDueDateAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("beforeDueDateAmount") }, "Input__Round")} />

                                    {getFormErrorMessage("beforeDueDateAmount")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="surcharges" className={classNames({ "p-error": isFormFieldValid("surcharges") }, "Label__Text")}>
                                        Surcharges
                                    </label>
                                    <InputText id="surcharges" placeholder="auto" name="surcharges" value={formik.values.surcharges} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("surcharges") }, "Input__Round")} />

                                    {getFormErrorMessage("surcharges")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="afterDueDateAmount" className={classNames({ "p-error": isFormFieldValid("afterDueDateAmount") }, "Label__Text")}>
                                        After Due Date Ammount
                                    </label>
                                    <InputText id="afterDueDateAmount" placeholder="auto" name="afterDueDateAmount" value={formik.values.afterDueDateAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("afterDueDateAmount") }, "Input__Round")} />

                                    {getFormErrorMessage("afterDueDateAmount")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="Form__Header">
                        <h1>Financial Information</h1>
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="paymentMode" className={classNames({ "p-error": isFormFieldValid("paymentMode") }, "Label__Text")}>
                                        Payment Mode<span className="Label__Required">*</span>
                                    </label>
                                    <Dropdown
                                        id="paymentMode"
                                        placeholder=""
                                        options={baseLocationOptions}
                                        optionLabel="description"
                                        name="paymentMode"
                                        value={formik.values.paymentMode}
                                        onChange={formik.handleChange}
                                        className={classNames({ "p-invalid": isFormFieldValid("paymentMode") }, "Dropdown__Round")}
                                    />
                                    {getFormErrorMessage("paymentMode")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="accountNumber" className={classNames({ "p-error": isFormFieldValid("accountNumber") }, "Label__Text")}>
                                        Account Number
                                    </label>
                                    <InputText id="accountNumber" placeholder="" name="accountNumber" value={formik.values.accountNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("accountNumber") }, "Input__Round")} />

                                    {getFormErrorMessage("accountNumber")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="cheaqueNumber" className={classNames({ "p-error": isFormFieldValid("cheaqueNumber") }, "Label__Text")}>
                                        Cheaque Number
                                    </label>
                                    <InputText id="cheaqueNumber" placeholder="" name="cheaqueNumber" value={formik.values.cheaqueNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("cheaqueNumber") }, "Input__Round")} />

                                    {getFormErrorMessage("cheaqueNumber")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="payOrder" className={classNames({ "p-error": isFormFieldValid("payOrder") }, "Label__Text")}>
                                        Pay Order / Cash
                                    </label>
                                    <InputText id="payOrder" placeholder="" name="payOrder" value={formik.values.payOrder} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("payOrder") }, "Input__Round")} />

                                    {getFormErrorMessage("payOrder")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="RecieveAmount" className={classNames({ "p-error": isFormFieldValid("RecieveAmount") }, "Label__Text")}>
                                        Recieve Amount
                                    </label>
                                    <InputText id="RecieveAmount" placeholder="" name="RecieveAmount" value={formik.values.RecieveAmount} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("RecieveAmount") }, "Input__Round")} />

                                    {getFormErrorMessage("RecieveAmount")}
                                </div>
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <div className="p-field">
                                    <label htmlFor="accessSort" className={classNames({ "p-error": isFormFieldValid("accessSort") }, "Label__Text")}>
                                        Access / Sort
                                    </label>
                                    <InputText id="accessSort" placeholder="" name="accessSort" value={formik.values.accessSort} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("accessSort") }, "Input__Round")} />

                                    {getFormErrorMessage("accessSort")}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="Down__Btn">
                        <Button disabled={loading} label="Reset" className="Btn__Transparent" />
                        <Button disabled={loading} label="Submit" className="Btn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default UtilityBillCollection;
